import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-snackbar-html',
    template: `
        <div class="snackbar-content">
            <div class="label-content" [innerHTML]="data"></div>
            <button class="custom-button" mat-button (click)="closeSnackbar()">Okay</button>
        </div>
    `,
    styles: [
        `
            .custom-button {
                color: #fff;
                height: 36px;
                border-radius: 50px;
                margin-left: 16px;
                padding: 0 16px;
                cursor: pointer;
            }
            .snackbar-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;
                width: 100%;
                flex-grow: 1;
                box-sizing: border-box;
            }

            ::ng-deep .mdc-snackbar__label {
                padding: 0px !important;
            }
        `,
    ],
})
export class SnackbarHtmlComponent {
    constructor(
        public snackBarRef: MatSnackBarRef<SnackbarHtmlComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: Element
    ) {}

    closeSnackbar(): void {
        this.snackBarRef.dismiss();
    }
}
